import { ProductId } from '../product/constants';
import { WLProductT } from '../wl_product/model';

const PRODUCT_DATA = 'PRODUCT_DATA';

export const setProductData = (data: WLProductT) =>
  data
    ? localStorage.setItem(PRODUCT_DATA, JSON.stringify(data))
    : localStorage.removeItem(PRODUCT_DATA);

export const getProductData = (): (WLProductT & { email: string }) | null | undefined => {
  const productData = localStorage.getItem(PRODUCT_DATA);
  return productData && JSON.parse(productData);
};

/** WL product row UUID from cached product details (not the ProductUuid enum). */
export const getCurrentWlProductUuid = (): string | null | undefined => {
  const productDataParsed = getProductData();
  return productDataParsed?.uuid;
};

export const getCurrentProductTypeId = (): ProductId | null | undefined => {
  const productDataParsed = getProductData();
  return productDataParsed && productDataParsed.product_id;
};

export const getCurrentGroupUuid = (): string | null | undefined => {
  const productDataParsed = getProductData();
  return productDataParsed?.group_uuid;
};

export const getCurrentLogo = () => {
  const productDataParsed = getProductData();
  return (
    productDataParsed && {
      file_content: productDataParsed.logo,
      mimetype: productDataParsed.logo_mimetype,
    }
  );
};

export const getCurrentFavicon = () => {
  const productDataParsed = getProductData();
  return (
    productDataParsed && {
      file_content: productDataParsed.favicon,
      mimetype: productDataParsed.favicon_mimetype,
    }
  );
};

export const getCurrentProductTheme = () => {
  const productDataParsed = getProductData();
  return (
    productDataParsed && {
      primary_color: productDataParsed.primary_color,
      secondary_color: productDataParsed.secondary_color,
    }
  );
};

export const getCurrentProductName = (defaultName: string = '') => {
  const productDataParsed = getProductData();
  return (productDataParsed && productDataParsed.display_name) || defaultName;
};

export const getCurrentProductTerms = () => {
  const productDataParsed = getProductData();
  return (productDataParsed && productDataParsed.terms_url) || '';
};

export const getCurrentProductHelpCenterUrl = () => {
  const productDataParsed = getProductData();
  return productDataParsed?.help_center_url;
};

export const getCurrentProductPrivacyUrl = () => {
  const productDataParsed = getProductData();
  return productDataParsed?.privacy_url;
};

export const getCurrentProductStatusUrl = () => {
  const productDataParsed = getProductData();
  return productDataParsed?.status_url;
};

export const getCurrentProductSupportEmail = (defaultName: string = '') => {
  const productDataParsed = getProductData();
  return (productDataParsed && productDataParsed.email) || defaultName;
};

export const getCurrentProductRewardsEnabled = () => {
  const productDataParsed = getProductData();
  return productDataParsed?.is_reward_enabled;
};

export const getCurrentProductInvitationOnly = () => {
  const productDataParsed = getProductData();
  return productDataParsed?.is_invitation_only;
};
